import React from 'react';
import { getQuoteInquiryApiBase } from '../utils/quoteInquiryApi';
import { DEFAULT_PRICING_SETTINGS, normalizePricingSettings } from '../utils/csomagStyleEstimate';

let cachedPricingSettings = null;
let pendingPricingSettings = null;

async function fetchPricingSettings() {
  const apiBase = getQuoteInquiryApiBase();
  const response = await fetch(`${apiBase}/api/public/pricing-settings`);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || 'Nem sikerült betölteni az árbeállításokat.');
  }
  return normalizePricingSettings(data?.settings);
}

export default function usePricingSettings() {
  const [pricingSettings, setPricingSettings] = React.useState(() =>
    normalizePricingSettings(cachedPricingSettings || DEFAULT_PRICING_SETTINGS),
  );
  const [loading, setLoading] = React.useState(!cachedPricingSettings);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    let alive = true;
    if (!pendingPricingSettings) {
      pendingPricingSettings = fetchPricingSettings()
        .then((settings) => {
          cachedPricingSettings = settings;
          return settings;
        })
        .finally(() => {
          pendingPricingSettings = null;
        });
    }

    pendingPricingSettings
      .then((settings) => {
        if (!alive) return;
        setPricingSettings(settings);
        setError('');
      })
      .catch((err) => {
        if (!alive) return;
        setPricingSettings(normalizePricingSettings(DEFAULT_PRICING_SETTINGS));
        setError(err?.message || 'Nem sikerült betölteni az árbeállításokat.');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  return { pricingSettings, loading, error };
}
